import Cookies from "js-cookie";
import _ from "lodash";

declare var appConfig: any;
const langCookieName = appConfig.cookie.lang || "Esperantus_Language_languageSwitcher";

export default class ResourceHelper {
    private static __resources = {
        en: {
            notFoundOrExists: "Isbn not found or already exists",
            exists:"ISBN already exists",
            editCredentials:"Edit credentials",
            sendRequest:"Send change request",
            deletelicence: "Delete licence assignment",
            EditNote:"Edit note",
            mailPlaceholder: "Enter mail adress...",
            assignLicence:"Assign licence",
            exportLicence:"Export overview",
            totalPageItems:"Total page Item",
            lastModificationDate: "Last modification date",
            creationDate:"Creation date",
            wishlistName: "Wishlist name",
            wishlistComment:"Comment",
            titleCount:"Number",
            WishlistaddedSuccessfully: "Wishlist added successfully",
            exportedSuccess: "Successfully exported",
            exportAllDetailbtn: "Export all to CSV file",
            addAllTitlesToCart: "Add all to shopping cart",
            removeSelectWishItem: "Remove selected item",
            exportDetailButton:"Export selected ot CSV file",
            addSelectedtoWishlist:"Add selected to shopping cart",
            ConfirmBody: "Are you sure you want to delete this entry?",
            AddMarket: "Add wishlist",
            confirmDelete: "Confirm deletion",
            DeleteRow: "Delete row",
            ExportRow: "Export row",
            ExportRowBtn:"Export row",
            EditRow: "Edit Row",
            save: "Save",
            search: "Search",
            metaSearch: "Meta search",
            noEntries: "There are no entries.",
            moduleAssignment: "Module assignment",
            moduleAssignmentBody: "Here you can assign single or all existing companies to a module and activate or deactivate this feature for all users of the companies.",
            moudleAssignName: "Module name",
            moduleAssignAllCompanies: "Assign to all companies",
            moduleAssignToCompany: "Assign to company",
            moduleAssignToCompanyBtn: "Assign to company",
            moduleAssigningCompaniesHeader: " Assigning companies",
            moduleAssignExistingCompanies: "Existing companies",
            moduleAssignedCompanies: "Assigned companies",
            addIsbnToWishlist: "Add article directly to watch list via ISBN.",
            noWishlistsFound: "No wishlists were found for the current user",
            bookLoans: "Book loans",
            myProduct: "My products",
            onlineLicenses: "Online licences",
            journalLoans: "Journal loans",
            circulationSlips: "Circulation slips",
            onlineProducts: "Online products",
            circulationSlipTitle: "Audience",
            billingAddress: "Billing Address",
            deliveryAddress: "Delivery Address",
            loading: "Loading...",
            close: "Close",
            userName: "User name",
            firstName: "First Name",
            lastName: "Last Name",
            noData: "No data to show",
            showDetails: "Show Details",
            deliveryNote: "Delivery Note",
            invoiceNote: "Invoice Note",
            clearAggregations: "Clear Aggregations",
            resultPerPage: "Result Per Page",
            sortBy: "Sort By",
            noResult: "No titles found.",
            productdescription: "Product description",
            biographicalNote: "Biographical Note",
            keyWords: "Keywords, Classifications and Subjects",
            addShoppingCart: "Add To Shopping Cart",
            goToDetailPage: "Go To Detail Page",
            goToCart: "Show shopping cart",
            addToWishList: "Add To WishList",
            addWishlistTitelLabel: "Add wishlists by title:",
            addToWishListByTitle: "  Add to wishlist",
            searchByFile: " Search file",
            uploadFile: " Upload file",
            SearchByIsbn: "Search by ISBN",
            searchTerm: "Search Result",
            elasticSearchPlaceholder: "Title, ISBN, Author...",
            back: "back",
            loan: "Loan",
            return: "Return",
            overView: "Over View",
            title: "Title",
            subtitle: "Subtitle",
            delete: "Delete",
            add: "add",
            searchPlaceHoder: "Titel, ISBN, Autor",
            availability: "Availability",
            Available: "Available",
            willBeOrderable: "Will Be Orderable",
            notAvailable: "Not Available",
            notInLibrary: "Not in library",
            inLibrary: "In library",
            convertedPrice: "Converted according to ECB",
            minPrice: "Minimum price",
            maxPrice: "Maximum price",
            send: "Send",
            cancel: "Cancel",
            searchFormTitle: "Search request",
            searchFormHelp: "You are welcome to forward your search query to our team. We will contact you immediately regarding the publication you are looking for. Please enter your desired title and the required number of titles here:",
            searchFormNoResults: "You searched for '{0}', but no matches were found?<br />You are welcome to forward your search request to our team. We will contact you regarding the publication you are looking for. Please enter the desired title and number of titles here:",
            formContentSent: "Your data was sent successfully.",
            fromInput: "E-mail address",
            titleInput: "Search title",
            titleQuantitiesInput: "Title quantities",
            messageInput: "Optional message",
            telephoneInput: "Telephone number",
            count: "Count",
            comment: "Comment",
            phone: "Phone number",
            email: "E-Mail",
            from: "From",
            optionalField: "(optional)",
            requiredOverride: "{_field_} is a required field",
            emailOverride: "Please enter a valid e-mail address",
            betweenOverride: "Please enter the desired number of titles",
            advancedSearch: "Advanced search",
            isbnTitle: "ISBN / ISSN / EAN",
            keywords: "Keywords",
            author: "Author",
            publisher: "Publisher",
            productForm: "Product Form",
            publicationLanguages: "Language",
            yearFrom: "Year",
            yearTo: "to",
            priceFrom: "Price in EUR",
            priceTo: "to",
            select: "select",
            priceLabel: "Price in EUR",
            to: "to",
            minmaxDigits: "Please enter at least {0} digits for the {_field_} field.",
            minmaxNumber: "Please enter a value between {0} and {1} for the {_field_} field.",
            minmaxCharacters: "Please enter at least {0} characters for the {_field_} field.",
            relevance: "Relevance",
            pubYear: "Publication year",
            prices: "Prices",
            desc: "descending",
            asc: "ascending",
            priceSortNote: "/ Import titles sorted to the end",
            sum: "Sum",
            totalSum: "Total Sum",
            productType: "Product Type",
            costCenter: "Cost Center",
            departmentName: "Department",
            quantity: "quantity",
            unitPrice: "unit Price",
            total: "Total",
            tax: "Tax",
            orderNumber: "Order Number",
            orderDate: "Order Date",
            orderDateBuchservice: "Receipt date",
            company: "Company",
            reportPeriod: "Report Period",
            noResultFound: "No Results",
            documentNumber: "Document number",
            orderIndication: "Order Reference",
            noFilterSelectedError: "Please select at least one filter criterion.",
            library: "Library",
            subscription: "Subscription",
            titleImage: "Image",
            journal: "Journal",
            RRPExcludingTax: "Price for single issue",
            RRPIncludingTax: "Annual subscription fee (Germany)",
            FixedRetailPriceExcludingTax: "Annual subscription fee (International)",
            FixedRetailPriceIncludingTax: "Special price for subscriptions of other journals",
            SuppliersNetPriceExcludingTax: "Special price for institutions",
            SuppliersNetPriceExcludingTaxRentalGoods: "Special price for students and pupils",
            SuppliersNetPriceIncludingTax: "Special price for members, societies and associations",
            SuppliersAlternativeNetPriceExcludingTax: "Combined price for print + online subscription (Germany)",
            SuppliersAlternativeNetPriceIncludingTax: "Combined price for print + online subscription (International)",
            SpecialSaleRRPExcludingTax: "",
            SpecialSaleRRPIncludingTax: "Online or digital subscription",
            termsAndConditions: "Terms and conditions",
            audience: "Audience ",
            termOfNotice: "Term of notice",
            assignDepartments: "Assign Departments",
            searchDepartments: "Search",
            selection: "Select",
            assignCostCenter: "Assign Cost Center",
            searchCostCenter: "Search",
            selectAllDepartments: "Select all departments",
            removeAllDepartments: "Remove all departments",
            selectAllCostCenters: "Select all cost centers",
            removeAllCostCenters: "Remove all cost centers",
            assignedDepartments: "Assigned departments",
            notAssignedDepartments: "Not assigned departments",
            assignedCostCenters: "Assigned cost centers",
            notAssignedCostCenters: "Not assigned cost centers",
            publicationDate: "Publication Date",
            volume: "Volume",
            ODB_Title_Popup: "Trial Access/Order",
            Priceless_Title_Popup: "Price request",
            ODB_Text_Popup: "<label>Wollen Sie einen Testzugang?</label><label>Bitte geben Sie im Feld Bemerkung die benötigten Nutzer mit Name, Vorname und E- Mailadresse an und ob sie unverbindlich testen oder fest bestellen wollen.</label><label>Wir beantworten gerne Ihre Anfrage, prüfen ob abweichende Konditionen für Sie möglich sind und informieren Sie entsprechend.</label>",
            Priceless_Text_Popup: "<label>You are welcome to forward your price request to our team.</label><label>We will contact you immediately regarding the publication you are looking for.</label><label>Please indicate the title and number of titles you require here:</label>",
            ODB_ButtonTextPopup: "Trial Access",
            Priceless_ButtonTextPopup: "Price request",
            olTitle: 'Title',
            olPublisher: 'Publisher',
            olAvailableLicenses: 'Available licenses',
            olAssignedLicenses: 'Count',
            olFirstName: 'First name*',
            olLastName: 'Last name*',
            olUserName: 'Username*',
            olEmail: 'E-Mail',
            olComment: 'Comment',
            olCreatedDate: 'Created Date',
            olSubscriptionId: 'Subscriptionid',
            olLicenseInfo: 'License Info',
            olMultipleUsers: 'Multiple useres assigned',
            calculatedPriceTitle: "Depending on currency fluctuations and customs costs",
            calculatedPriceLabel: "Our exclusive price for you",
            unPricedItemTypeCode1: "Free of charge",
            unPricedItemTypeCode2: "Price to be announced",
            unPricedItemTypeCode3: "Not sold separately",
            unPricedItemTypeCode4: "Contact supplier",
            unPricedItemTypeCode5: "Not sold as set",
            unPricedItemTypeCode6: "Revenue share",
            subscribtionId: "SubscribtionId",
            licensesManagementFileName: "LicensesManagement",
            onlineAccessButtonText: "Online Access",
            saveCredentialsErrorMessage: "Error saving single sign on credentials.",
            Lib_Inv_Header: "Library Inventory",
            Lib_Inv_SearchByISBN: "Search By ISBN:",
            Lib_Inv_ChooseDepartment: "Choose Department",
            Lib_Inv_Departments: "Departments",
            Lib_Inv_ThereIsNoProducts: "There is no products!",
            Lib_Inv_DistinctiveTitle: "Distinctive title",
            Lib_Inv_EditionStatement: "Edition statement",
            Lib_Inv_Publishers: "Publishers",
            Lib_Inv_Price: "Price",
            Lib_Inv_Availability: "Availability",
            Lib_Inv_Import: "Import",
            Lib_Inv_ImportSelected: "Import selected",
            Lib_Inv_LibraryImportedSuccessfully: "Library imported successfully",
            Lib_Inv_FailedToImportLibrary: "Failed to import library",
            Lib_Inv_Search: "Search",
            Lib_Inv_ProductReferrence: "ISBN/EAN",
            Lib_Inv_Select: "Select",
            Lib_Inv_FailedToGetDepartments: "Failed to get departments",
            Lib_Inv_ISBNNotValid: "ISBN not valid!",
            Lib_Inv_Alert_Header: "Not found ISBNs",
            OL_AddNoneSystemUser: "Add Non-System User",
            OL_SelectUser: "Select User",
            OL_MaxLicenseError: "Maximum licenses exceeded!",
            OL_NoChangeAllowed: "No change allowed",
            OrderTime: "Order time",
            OrderTimeDays: "days",
            keywords_Warengruppe: "Good Groups",
            keywords_Schlagworte: "Keywords",
            keywords_NewbooksClassification: "NEWBOOKS",
            keywords_Wgs: "Wgs",
            keywords_Stil: "Style",
            keywords_Interessen: "Interest",
            keywords_Bildung: "Educational purpose",
            keywords_Zeitepoche: "Time period",
            keywords_Sprache: "Language",
            keywords_Ort: "Place",
            keywords_Thema: "Theme",
            keywords_Lesemotive: "Reading Motives",
            furtherInfo_Audience: "Audience",
            expectedShipDate: "Expected Delivery Date",
            mailAddress: "E-Mail",
            companyName: "Company name",
            department: "Department",
            browse: "Browse",
            notFoundList: "Not found list ",
            noFileChoosen: "No file choosen",
            addedSuccessfully: "Added successfully ",
            newbooksClassification: "NEWBOOKS",
            totalClassification: "Total selected classifications",
            chooseClassification: "Select Classification",
            themaClassification: " Thema Classification",
            chooseThemaClassification: "Select Thema Classification",
            chooseNewbooksClassification: "Select  NEWBOOKS  Classification",
            noAuthor: "There is no author",
            noFoundTitle: "No title available",
            belowWishlistLabel: "Here you have two options to enter a list of ISBNs. The system will automatically identify the ISBNs and add the titles to your wishlist. Please insert the ISBNs of the desired titles in the field below, or upload an appropriate file.",
            userDetail: "User Detail",
            Series: "Series",
            NumberOfPieces: "Number of pieces",
            enterSSOPassword: "Please enter your user password to see the SSO credentials",
            ssoType: "SSO Type",
            URLindividual: "URL Individual",
            URLStandard: "URL Default",
            password: 'Password',
            passwordNotValid: "Password is not valid!",
            submit: "Submit",
            cancelSSOEnterPassword: "Cancel",
            users: "Users",
            enterCurrentPassword: "Enter your current password...",
            passwordRequired: "Password is required!",
            RequestChangeHeader: "Request licence change",
            RequestChangeMessageLabel: "Message:",
            RequestChangePlaceholder: "Enter your message...",
            RequestChangeRequired: " Message is required !",
            RequestChangeBtn: "Send",
            RequestChangeMailHeader: "Licence change request",
            RequestChangeMailAdress: "Request sender adress:",
            MessageSent: "Message Sent",
            NotAuthMessage: "Sorry, you don´t have access to this module.",
            createWishList: "Create Wishlist",
            Downloading: "Downloading Pdf",
            PdfDownloadedSuccessfully: "Pdf Download Successfully",
            exportPdf: "PDF Export",
            downloadFailed: "Failed to download PDF",
            boorbergUsername: "Identifier",
            standardUsername: "Username",
            removeSelectWish: "Remove selected item",
            addNewWishlist: "Add a new wishlist",
            watchlists: "wishlist",
            wishlistOf: "of",
            page: "Page",
            hit: "Result for",
            activeFilter: "Active Filter",
            Author: "Author",
            Editor: "Editor",
            Language:"Language",
            PublicationCountry:"Publication Country",
            Bundle:"Bundle",
            Measures: "Measures",
            pages: "Pages",
            duration:"Duration",
            filesize: "File Size",
            minutes: "minutes",
            // APSSO Masseges
            success: "Success",
            APSSOsuccess: "You have successfully opened the Premium Approval Plan in a new tab.",
            failed: "Failed",
            retry: "Retry",
            failedBadRequest: "Oops! Something's not quite right. Please check your request and try again.",
            failedNotFound: "Oops! It seems that the customer information couldn't be found. Please try again later.",
            failedServiceUnavailable: "Oops! We couldn't add you to the Premium Approval Plan.",
            failedInternalServerError: "Oops! We're experiencing some technical difficulties. Our team is already working on fixing it. Please try again later.",
            pleaseEnterAtLeast3characters:"Please Enter at least 3 characters",
            odbButtonHeader: "Order Request",
            odbPopupTitle: "You are welcome to forward an inquiry to our team. Please enter your contact details below",
            odbEmailAddress: "E-Mail",
            odbOrderType: "Order Type",
            odbFixedOrder: "Fixed Order",
            odbNonBindungTestOrder: "Test Order",
            odbStreet: "Street",
            odbNR: "NR.",
            odbPostCode: "Post Code",
            odbLocation: "Location",
            odbAuthPopupTitle: "You are welcome to forward your price request to our team.We will contact you immediately regarding the publication you are looking for.Please indicate the title and number of titles you require here:",
            odbUserInfo: "Remarks(user information)",
            unAuthUserInfo: "User details / Different delivery address / Remarks",
            completeRecaptcha: "Please complete the reCAPTCHA before submitting the form.",
            NamePopup: "Name",
            EnterNamePopup: "Enter Name",
            AddCommentPopup: "Add Comment",
            SaveSearchPopup: "Save Search",
            CreationTimePopup: "Creation Time",
            DescriptionPopup: "Description",
            AddBookmarkPopup: "Bookmark added successfuly",
            AddBookmarkPopupError: "Could not create bookmark",
            deletedSuccess: "Bookmark deleted",
            updatedSuccess: "Updated successfully",
            errorOccured: "Error occurred",
            confirmDeleteBody: "Are you sure you want to delete this?",
            yesDelete: "Delete",
            noCancel: "Cancel",
            personIdentifier: "more products by this author"
        },

        fr: {    
            RequestChangeMailAdress: "Absender- Mailadresse: ",
            RequestChangeMailHeader: "Lizenzänderung-Anfrage über",
            RequestChangeBtn: " Senden",
            RequestChangeRequired: "Das Textfeld darf nicht leer sein",
            RequestChangePlaceholder: "Bitte geben Sie Ihre Nachricht ein...",
            RequestChangeMessageLabel: "Nachricht:",
            RequestChangeHeader: "Lizenzänderung anfragen",
            save: "Speichern",
            search: "Chercher",
            noWishlistsFound: "No wishlists were found for the current user",
            bookLoans: "Prêts de livres",
            onlineLicenses: "Online licences",
            journalLoans: "Prêts de journal",
            circulationSlips: "Feuillet de circulation",
            onlineProducts: "Produits en ligne",
            circulationSlipTitle: "Public",
            billingAddress: "Adresse de facturation",
            deliveryAddress: "Adresse de livraison",
            loading: "Chargement...",
            close: "Fermer",
            userName: "Nom d'utilisateur",
            firstName: "First Name",
            lastName: "Last Name",
            noData: "Aucune donnée à afficher",
            showDetails: "Afficher les détails",
            deliveryNote: "Lieferschein",
            invoiceNote: "Rechnungs",
            clearAggregations: "Clear Aggregations",
            resultPerPage: "Result Per Page",
            sortBy: "Sort By",
            noResult: "No titles found.",
            productdescription: "Product description",
            biographicalNote: "Biographical Note",
            keyWords: "Schlagworte, Warengruppen und Fachgebiete",
            addShoppingCart: "Add To Shopping Cart",
            goToDetailPage: "Aller à la page de détail",
            goToCart: "Voir Panier d'achat",
            addToWishList: "Add To WishList",
            addWishlistTitelLabel: "Add wishlists by title:",

            addToWishListByTitle: "  Add to wishlist",
            searchByFile: " Search file",
            uploadFile: " Upload file",
            SearchByIsbn: "Search by ISBN",
            searchTerm: "Search Result",
            elasticSearchPlaceholder: "Titre, ISBN, Auteur...",
            back: "back",
            loan: "Loan",
            return: "Return",
            overView: "Over View",
            title: "Title",
            delete: "Delete",
            add: "add",
            searchPlaceHoder: "Titel, ISBN, Autor",
            availability: "lieferbar",
            Available: "Disponible",
            willBeOrderable: "im Moment nicht lieferbar",
            notAvailable: "nicht lieferbar",
            notInLibrary: "Not in library",
            inLibrary: "In library",
            convertedPrice: "Converted according to ECB",
            minPrice: "Prix minimum",
            maxPrice: "Prix maximum",
            send: "Envoyer",
            cancel: "Annuler",
            searchFormTitle: "Recherche",
            searchFormHelp: "Veuillez entrer le titre que vous recherchez et le nombre d'articles dont vous avez besoin ici:",
            searchFormNoResults: "Vous avez cherché '{0}', mais aucune correspondance n'a été trouvée?<br />Vous pouvez envoyer votre demande de recherche au service des réservations. Nous vous contacterons au sujet de la publication que vous recherchez. Veuillez entrer le titre et le nombre de titres souhaités ici:",
            formContentSent: "Vos données ont été envoyées avec succès.",
            fromInput: "Adresse e-mail",
            titleInput: "Titre de la recherche",
            titleQuantitiesInput: "Numéro du titre",
            messageInput: "Message optionnel",
            telephoneInput: "Numéro de téléphone",
            count: "Compter",
            comment: "Remarque",
            phone: "Numéro de téléphone",
            email: "E-Mail",
            from: "De",
            optionalField: "(optional)",
            requiredOverride: "{_field_} est un champ obligatoire",
            emailOverride: "S'il vous plaît, mettez une adresse email valide",
            betweenOverride: "S'il vous plaît entrer le nombre souhaité de titres",
            advancedSearch: "Recherche Avancée",
            isbnTitle: "ISBN / ISSN / EAN",
            keywords: "Mots clés",
            author: "Auteu",
            publisher: "Maison d'édition",
            productForm: "Apparence",
            publicationLanguages: "Langue",
            yearFrom: "Année",
            yearTo: "à",
            priceFrom: "Prix à partir",
            priceTo: "à",
            select: "sélectionner",
            priceLabel: "Price in EUR",
            to: "to",
            minmaxDigits: "Veuillez saisir au moins {0} chiffres pour le champ {_field_}.",
            minmaxNumber: "Veuillez saisir une valeur comprise entre {0} et {1} pour le champ {_field_}.",
            minmaxCharacters: "Veuillez saisir au moins {0} caractères pour le champ {_field_}.",
            relevance: "Relevance",
            pubYear: "Publication year",
            prices: "Prices",
            desc: "descending",
            asc: "ascending",
            priceSortNote: "/ Import titles sorted to the end",
            totalSum: "Total Sum",
            productType: "Product Type",
            costCenter: "Cost Center",
            departmentName: "Department",
            quantity: "quantity",
            unitPrice: "unitPrice",
            total: "Total",
            tax: "Tax",
            orderNumber: "Order Number",
            orderDate: "Order Date",
            orderDateBuchservice: "Receipt date",
            company: "Company",
            reportPeriod: "Report Period",
            noResultFound: "No Results",
            documentNumber: "Document number",
            orderIndication: "Bestellzeichen",
            noFilterSelectedError: "Veuillez sélectionner au moins un critère de filtrage.",
            library: "Library",
            subscription: "Subscription",
            titleImage: "Cover",
            publicationDate: "Publication Date",
            licensesManagementFileName: "LicensesManagement",
            onlineAccessButtonText: "Online access",
            saveCredentialsErrorMessage: "Error saving single sign on credentials.",
            Lib_Inv_ProductReferrence: "ISBN/EAN",
            OrderTime: "Order time",
            OrderTimeDays: "days",
            mailAddress: "E-Mailadresse",
            companyName: "Firmenname",
            department: "Abteilung",
            browse: "Browse",
            notFoundList: "Not found list ",
            noFileChoosen: "No file choosen",
            addedSuccessfully: "Title(s) added to wishlist",
            newbooksClassification: "NEWBOOKS",
            totalClassification: "Total selected classifications",
            chooseClassification: "Select Classification",
            themaClassification: " Thema Classification",
            keywords_Warengruppe: "Good Groups",
            chooseThemaClassification: " Thema Klassifikationen auswählen",
            chooseNewbooksClassification: " NEWBOOKS Klassifikationen auswählen",
            noAuthor: "There is no author",
            noFoundTitle: "Keine titel verfügbar",
            belowWishlistLabel: "Here you have two options to enter a list of ISBNs. The system will automatically identify the ISBNs and add the titles to your wishlist. Please insert the ISBNs of the desired titles in the field below, or upload an appropriate file.",
            userDetail: "Détail De L'utilisateur",
            enterSSOPassword: "Please enter your user password to see the SSO credentials",
            passwordNotValid: "Password is not valid!",
            submit: "Submit",
            cancelSSOEnterPassword: "Cancel",
            users: "Users",
            MessageSent: "Ihre Nachricht wurde versende",
            watchlists: "wishlist",
            wishlistOf: "of",
            page: "Page",
            hit: "Result for",
            activeFilter: "Active Filter",
            Author: "Author",
            Editor: "Editor",
            Language: "Language",
            PublicationCountry: "Publication Country",
            Bundle: "Bundle",
            Measures: "Measures",
            // APSSO Masseges
            success: "Succès",
            APSSOsuccess: "Vous avez ouvert avec succès le plan d'approbation Premium dans un nouvel onglet.",
            retry: "Recommencez",
            failed: "Fehlgeschlagen",
            APPSSOfailed: "Échec de l'ouverture du plan d'approbation Premium.",
            failedBadRequest: "Oups ! Quelque chose ne va pas. Veuillez vérifier votre demande et réessayer.",
            failedNotFound: "Oups ! Il semble que les informations du client ne puissent pas être trouvées. Veuillez réessayer ultérieurement.",
            failedServiceUnavailable: "Oups ! Nous n'avons pas pu vous ajouter au Plan d'Approbation Premium.",
            failedInternalServerError: "Oups ! Nous rencontrons des difficultés techniques. Notre équipe travaille déjà pour résoudre le problème. Veuillez réessayer ultérieurement.",
            pleaseEnterAtLeast3characters: "veuillez entrer au moins 3 caractères",

            NamePopup: "Name",
            EnterNamePopup: "Entrer le nom",
            AddCommentPopup: "Ajouter un commentaire",
            SaveSearchPopup: "Sauvegarder la recherche",
            CreationTimePopup: "Temps de la création",
            DescriptionPopup: "Description",
            AddBookmarkPopup: "Signet ajouté avec succès",
            AddBookmarkPopupError: "Impossible de créer un signet",
            deletedSuccess: "Signet supprimé",
            updatedSuccess: "Mise à jour réussie",
            errorOccured: "Une erreur s'est produite",
            yesDelete: "Löschen",
            noCancel: "Abbrechen"
        },
        de: {
            exists: "Titel bereits auf dieser Merkliste ",
            editCredentials: "Zugangsdaten bearbeiten",
            sendRequest: "Lizenzänderung anfragen",
            EditNote: "Notiz bearbeiten",
            deletelicence:"Zuweisung löschen",
            mailPlaceholder:"E-Mailadresse eintragen...",
            assignLicence: "Lizenz zuweisen",
            exportLicence:"Lizenzübersicht exportieren",
            totalPageItems:"Seitenelemente insgesamt",
            lastModificationDate: "Geändert am",
            creationDate: "Erstellt am",
            wishlistName:"Merkliste",
            wishlistComment:"Kommentar",
            titleCount:"Titelanzahl",
            WishlistaddedSuccessfully: "Erfolgreich hinzugefügte Merkliste",
            exportedSuccess: "Erfolgreich exportiert",
            exportAllDetailbtn:"Alle Titel exportieren",
            addAllTitlesToCart: "Alle Titel in den Warenkorb legen",
            exportDetailButton: "Ausgewählte Titel exportieren",
            addSelectedtoWishlist: "Ausgewählte Titel in den Warenkorb legen",
            ConfirmBody:"Möchten Sie diesen Eintrag entfernen?",
            ExportRowBtn:"Als CSV exportieren",
            AddMarket:"Neue Merkliste hinzufügen",
            confirmDelete:"Einträge löschen",
            DeleteRow:"Merkliste löschen",
            ExportRow:"Merkliste exportieren",
            EditRow: "Merkliste bearbeiten",
            save: "Speichern",
            search: "Suche",
            metaSearch: "Metasuche",
            moduleAssignment: "Module zuweisen",
            addIsbnToWishlist: "Artikel direkt per ISBN zur Merkliste hinzufügen",
            noWishlistsFound: "Für den aktuellen Benutzer wurden keine Wunschlisten gefunden",
            noEntries: "Es sind keine Einträge vorhanden.",
            moduleAssignmentBody: "Hier können Sie einzelne oder alle vorhandene Firmen einem Modul zuordnen und dieses Feature für alle Benutzer der Firmen aktivieren bzw. deaktivieren.",
            moudleAssignName: "Modulname",
            moduleAssignAllCompanies: "Modul für alle Firmen aktivieren",
            moduleAssignToCompany: "Modul einzelnen Firmen zuordnen",
            moduleAssignToCompanyBtn: "Firmen zuordnen",
            moduleAssigningCompaniesHeader: "Firmen-Zuordnung",
            moduleAssignExistingCompanies: "Firmen-Auswahl",
            moduleAssignedCompanies: "zugeordnete Firmen",
            bookLoans: "Einzeltitel",
            myProduct: "Meine Produkte",
            onlineLicenses: "Online-Lizenzen",
            journalLoans: "Abonnements",
            circulationSlips: "Umlaufzettel",
            onlineProducts: "Online-Produkte",
            circulationSlipTitle: "Publikum",
            billingAddress: "Rechnungsadresse",
            deliveryAddress: "Lieferadresse",
            loading: "Wird geladen...",
            close: "Schließen",
            userName: "Kennung",
            firstName: "Vorname",
            lastName: "Nachname",
            noData: "Keine Daten gefunden",
            showDetails: "Details anzeigen",
            deliveryNote: "Lieferschein",
            invoiceNote: "Rechnungs",
            clearAggregations: "Alle Filter löschen",
            resultPerPage: "Anzahl Treffer",
            sortBy: "Sortieren",
            noResult: "Es wurden keine Treffer gefunden.",
            productdescription: "Produktinformationen",
            biographicalNote: "Weitere Informationen",
            keyWords: "Schlagworte, Warengruppen und Fachgebiete",
            addShoppingCart: "In den Warenkorb",
            goToDetailPage: "Zur Detailseite",//"Mehr anzeigen",
            goToCart: "Warenkorb anzeigen",
            addToWishList: "Auf die Merkliste setzen",
            addWishlistTitelLabel: "Titel zu Merkliste hinzufügen:",
            addToWishListByTitle: "Zu Merkliste hinzufügen",
            searchByFile: "ISBN manuell eintragen",
            uploadFile: "Datei hochladen",
            SearchByIsbn: "Suche nach ISBN",
            searchTerm: "Suchergebnis",
            elasticSearchPlaceholder: "Titel, ISBN, Autor...",
            back: "zurück",
            loan: "Ausleihe",
            return: "Rückgabe",
            overView: "Übersicht",
            title: "Titel",
            subtitle: "Untertitel",
            delete: "Löschen",
            add: "Hinzufügen",
            searchPlaceHoder: "Titel, ISBN, Autor, Schlagwort,...",
            availability: "lieferbar",
            Available: "lieferbar",
            willBeOrderable: "derzeit nicht lieferbar",
            notAvailable: "nicht lieferbar",
            notInLibrary: "nicht im Hausbestand",
            inLibrary: "im Hausbestand",
            convertedPrice: "Umgerechnet gemäß EZB",
            minPrice: "Minimaler Preis",
            maxPrice: "Maximaler Preis",
            send: "Senden",
            cancel: "Abbrechen",
            searchFormTitle: "Suchanfrage",
            searchFormNoResults: "Sie haben nach '{0}' gesucht, es wurden aber keine Treffer gefunden? Gerne können Sie Ihre Suchanfrage an unser Team weiterleiten. Wir setzen uns mit Ihnen bezüglich der gesuchten Publikation umgehend in Verbindung. Bitte geben Sie den von Ihnen gewünschten Titel und die benötigte Titelanzahl hier an:",
            searchFormHelp: "Gerne können Sie Ihre Suchanfrage an unser Team weiterleiten. Wir setzen uns mit Ihnen bezüglich der gesuchten Publikation umgehend in Verbindung. Bitte geben Sie den von Ihnen gewünschten Titel und die benötigte Titelanzahl hier an:",
            formContentSent: "Ihre Daten wurden erfolgreich gesendet.",
            fromInput: "E-Mail-Addresse",
            titleInput: "Titel suchen",
            titleQuantitiesInput: "Titelanzahl",
            messageInput: "Optionale Nachricht",
            telephoneInput: "Telefonnummer",
            count: "Anzahl",
            comment: "Bemerkung",
            phone: "Telefonnummer",
            email: "E-Mail",
            from: "Absender",
            optionalField: "(optional)",
            requiredOverride: "{_field_} ist ein Pflichtfeld",
            emailOverride: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            betweenOverride: "Bitte geben Sie die gewünschte Anzahl an Titeln ein",
            advancedSearch: "zur Profisuche",
            isbnTitle: "ISBN / ISSN / EAN",
            keywords: "Schlüsselwörter",
            author: "Autor",
            publisher: "Verlag",
            productForm: "Erscheinungsform",
            publicationLanguages: "Sprache",
            yearFrom: "Jahr",
            yearTo: "bis",
            priceFrom: "Preis in EUR",
            priceTo: "bis",
            select: "wählen",
            priceLabel: 'Preis in EUR',
            to: "bis",
            minmaxDigits: "Bitte geben Sie mindestens {0} Ziffern für das Feld {_field_} ein.",
            minmaxNumber: "Bitte geben Sie einen Wert zwischen {0} und {1} in das Feld {_field_} ein.",
            minmaxCharacters: "Bitte geben Sie mindestens {0} Zeichen für das Feld {_field_} ein.",
            relevance: "Relevanz",
            pubYear: "Erscheinungsjahr",
            prices: "Preise",
            desc: "absteigend",
            asc: "aufsteigend",
            priceSortNote: "/ Importtitel hinten einsortiert",
            sum: "Umsatz",
            totalSum: "Umsatz gesamt",
            productType: "Belegtyp",
            costCenter: "Kostenstelle",
            departmentName: "Abteilung",
            quantity: "Anzahl",
            unitPrice: "Einzelpreis",
            total: "Total",
            tax: "Steuern",
            orderNumber: "Belegnummer",
            orderDate: "Bestelldatum",
            orderDateBuchservice: "Belegdatum",
            company: "Firma",
            reportPeriod: "Berichtszeitraum",
            noResultFound: "Keine Ergebnisse",
            documentNumber: "Belegnummer",
            orderIndication: "Bestellzeichen",
            noFilterSelectedError: "Bitte wählen Sie mindestens ein Filterkriterium aus.",
            library: "Hausbestand",
            subscription: "Abonnement",
            titleImage: "Cover",
            journal: "Zeitschrift",
            RRPExcludingTax: "Einzelheftpreis", //01
            RRPIncludingTax: "Jahresabonnement Inland",  // 02
            FixedRetailPriceExcludingTax: "Jahresabonnement Ausland", //03
            FixedRetailPriceIncludingTax: "Vorzugspreis bei Bezug anderer Zeitschriften",//04
            SuppliersNetPriceExcludingTax: "Vorzugspreis für Institutionen", //05
            SuppliersNetPriceExcludingTaxRentalGoods: "Vorzugspreis für Studierende und Schüler", //06
            SuppliersNetPriceIncludingTax: "Vorzugspreis für Mitglieder, Gesellschaften, Verbände",//07
            SuppliersAlternativeNetPriceExcludingTax: "Kombi - Preis für Abonnement Print + Online Inland", //08
            SuppliersAlternativeNetPriceIncludingTax: "Kombi - Preis für Abonnement Print + Online Ausland", //09
            SpecialSaleRRPExcludingTax: "Online- bzw. Digital-Abonnement", //11
            SpecialSaleRRPIncludingTax: "", //12
            termsAndConditions: "Besondere Bedingungen",
            audience: "Zielgruppen ",
            termOfNotice: "Kündigungsfrist",
            assignDepartments: "Abteilungszugehörigkeit zuordnen",
            searchDepartments: "Abteilung suchen",
            selection: "Auswahl",
            assignCostCenter: "Kostenstellen zuordnen",
            searchCostCenter: "Kostenstelle suchen",
            selectAllDepartments: "Alle Abteilungen zuordnen",
            removeAllDepartments: "Alle Abteilungen abwählen",
            selectAllCostCenters: "Alle Kostenstellen zuordnen",
            removeAllCostCenters: "Alle Kostenstellen abwählen",
            notAssignedDepartments: "Nicht zugeordnete Abteilungen",
            assignedDepartments: "Zugeordnete Abteilungen",
            assignedCostCenters: "Zugeordnete Kostenstellen",
            notAssignedCostCenters: "Nicht zugeordnete Kostenstellen",
            publicationDate: "Erscheinungsdatum",
            expectedShipDate: "Voraussichtliches Auslieferungsdatum",
            volume: "Jahrgang",
            ODB_Title_Popup: "Testzugang/Bestellung",
            Priceless_Title_Popup: "Preisanfrage",
            ODB_Text_Popup: "<label>Wollen Sie einen Testzugang?</label><label>Bitte geben Sie im Feld Bemerkung die benötigten Nutzer mit Name, Vorname und E- Mailadresse an und ob sie unverbindlich testen oder fest bestellen wollen.</label><label>Wir beantworten gerne Ihre Anfrage, prüfen ob abweichende Konditionen für Sie möglich sind und informieren Sie entsprechend.</label>",
            Priceless_Text_Popup: "<label>Gerne können Sie Ihre Preisanfrage an an unser Team weiterleiten.</label><label>Wir setzen uns mit Ihnen bezüglich der gesuchten Publikation umgehend in Verbindung.</label><label>Bitte geben Sie den von Ihnen gewünschten Titel und die benötigte Titelanzahl hier an:</label>",
            ODB_ButtonTextPopup: "Testzugang",
            Priceless_ButtonTextPopup: "Preisanfrage",
            calculatedPriceLabel: "Unser Preis für Sie",
            calculatedPriceTitle: "Abhängig von Währungsschwankungen und Zollkosten",
            unPricedItemTypeCode1: "Produkt ist kostenlos",
            unPricedItemTypeCode2: "Preis steht noch nicht fest	",
            unPricedItemTypeCode3: "Produkt wird nicht einzeln verkauft	",
            unPricedItemTypeCode4: "Bitte wenden Sie sich an den Lieferanten",
            unPricedItemTypeCode5: "Produkt wird nicht im Set verkauft",
            unPricedItemTypeCode6: "Produkt unbepreist, aber über eine Umsatzbeteiligungsvereinbarung verfügbar",
            olTitle: 'Titel',
            olPublisher: 'Verlag',
            olAvailableLicenses: 'verfügbare Onlinezugänge',
            olAssignedLicenses: 'Anzahl',
            olFirstName: 'Vorname*',
            olLastName: 'Nachname*',
            olUserName: 'Benutzername*',
            olEmail: 'E-Mail',
            olComment: 'Notiz',
            olCreatedDate: 'Erstellt am',
            olSubscriptionId: 'Warenwirtschafts-ID',
            olLicenseInfo: 'Lizenzinformationen',
            olMultipleUsers: 'mehreren Benutzern zugewiesen',
            subscribtionId: 'Warenwirtschaftsnummer',
            licensesManagementFileName: "Lizenzverwaltung",
            onlineAccessButtonText: "Online-Zugang",
            saveCredentialsErrorMessage: "Fehler beim Speichern der Single Sign-On-Anmeldeinformationen.",
            Lib_Inv_Header: "Inventarisierung",
            Lib_Inv_SearchByISBN: "Suche nach ISBN:",
            Lib_Inv_ChooseDepartment: "Abteilung wählen",
            Lib_Inv_Departments: "Abteilungen",
            Lib_Inv_ThereIsNoProducts: "Es gibt keine Produkte!",
            Lib_Inv_DistinctiveTitle: "Titel",
            Lib_Inv_EditionStatement: "Auflage",
            Lib_Inv_Publishers: "Verlag",
            Lib_Inv_Price: "Preis",
            Lib_Inv_Availability: "Verfügbarkeit",
            Lib_Inv_Import: "Importieren",
            Lib_Inv_ImportSelected: "Titel importieren",
            Lib_Inv_LibraryImportedSuccessfully: "Bibliothek erfolgreich importiert",
            Lib_Inv_FailedToImportLibrary: "Bibliothek konnte nicht importiert werden",
            Lib_Inv_Search: "Suche starten",
            Lib_Inv_ProductReferrence: "ISBN/EAN",
            Lib_Inv_Select: "Auswählen",
            Lib_Inv_FailedToGetDepartments: "Fehler beim Abrufen von Abteilungen",
            Lib_Inv_ISBNNotValid: "ISBN nicht gültig!",
            Lib_Inv_Alert_Header: "Not found ISBNs",
            OL_AddNoneSystemUser: "E-Mailadresse eintragen",
            OL_SelectUser: "Benutzer auswählen",
            OL_MaxLicenseError: "Lizenzänderungen nur bei freien Lizenzen möglich",
            OL_NoChangeAllowed: "Keine Änderung erlaubt",
            OrderTime: "Lieferzeit",
            OrderTimeDays: "Tage",
            keywords_Schlagworte: "Schlagworte",
            keywords_NewbooksClassification: "NEWBOOKS",
            keywords_Wgs: "Wgs",
            keywords_Stil: "Stil",
            keywords_Interessen: "Interessen",
            keywords_Bildung: "Bildung",
            keywords_Zeitepoche: "Zeitepoche",
            keywords_Sprache: "Sprache",
            keywords_Ort: "Ort",
            keywords_Thema: "Thema",
            keywords_Lesemotive: "Lesemotive",
            furtherInfo_Audience: "Zielgruppe",
            mailAddress: "E-Mailadresse",
            companyName: "Firmenname",
            department: "Abteilung",
            browse: "Suchen",
            notFoundOrExists:"Der Titel ist bereits auf dieser Merkliste vorhanden",
            notFoundList: "Nicht gefundene ISBN ",
            noFileChoosen: "Keine Datei ausgewählt",
            addedSuccessfully: "Titel wurde(n) zur Merkliste hinzugefügt",
            newbooksClassification: "NEWBOOKS Klassifikationen",
            totalClassification: "Anzahl der ausgewählten Klassifikationen",
            chooseThemaClassification: " Thema Klassifikationen auswählen",
            chooseNewbooksClassification: " NEWBOOKS Klassifikationen auswählen",
            themaClassification: " Thema Klassifikationen",
            keywords_Warengruppe: "Warengruppe",
            noAuthor: "Keine Autoreninformation verfügbar",
            noFoundTitle: "Keine titel verfügbar",
            belowWishlistLabel: "Hier haben Sie zwei Optionen eine Liste von ISBNs anzugeben.Das System erkennt die ISBNs automatisch und fügt die Titel zu Ihrer Merkliste hinzu.Bitte tragen Sie die ISBNs der gewünschten Titel unten im Feld ein, oder laden Sie eine entsprechende Datei hoch.",
            userDetail: "Benutzer Detail",
            Series: "Reihe",
            NumberOfPieces: "Anzahl der Bände",
            enterSSOPassword: "Bitte geben Sie Ihr Benutzerpasswort ein, um die SSO-Zugangsdaten zu sehen",
            ssoType: "SSO Type",
            URLindividual: "URL Individual",
            URLStandard: "URL Default",
            password: 'Passwort',
            passwordNotValid: "Das Passwort ist nicht gültig!",
            submit: "Bestätigen",
            cancelSSOEnterPassword: "Abbrechen",
            users: "Benutzern",
            enterCurrentPassword: "Gib dein aktuelles Passwort ein...",
            passwordRequired: "Passwort wird benötigt!",
            RequestChangeMailAdress: "Absender- Mailadresse: ",
            RequestChangeMailHeader: "Lizenzänderung-Anfrage über",
            RequestChangeBtn: " Senden",
            RequestChangeRequired: "Das Textfeld darf nicht leer sein!",
            RequestChangePlaceholder: "Bitte geben Sie Ihre Nachricht ein...",
            RequestChangeMessageLabel: "Nachricht:",
            RequestChangeHeader: "Lizenzänderung anfragen",
            NotAuthMessage: "Sie haben keinen Zugriff auf dieses Modul.",
            MessageSent: "Ihre nachricht wurde versende",
            createWishList: "Neue Merkliste erstellen",
            Downloading: "Produktdaten PDF wird erstellt",
            PdfDownloadedSuccessfully: "Produktdaten PDF wurde heruntergeladen",
            exportPdf: "Produktdaten als PDF herunterladen",
            downloadFailed: "PDF konnte nicht heruntergeladen werden",
            boorbergUsername: "Kennung",
            standardUsername: "Nutzername",
            removeSelectWish: "Ausgewählte Merklisten löschen",
            removeSelectWishItem: "Ausgewählte Titel löschen",
            addNewWishlist: "Merkliste hinzufügen",
            watchlists: "Merkliste",
            wishlistOf: "von",
            page: "Seite",
            hit: "Treffer für",
            activeFilter: "Aktive Filter",
            Author: "Autoren",
            Editor: "Herausgeber",
            Language: "Sprache",
            PublicationCountry: "Publikationsort",
            Bundle: "Bundle",
            Measures: "Abmessungen",
            pages: "Seiten",
            duration: "Dauer",
            filesize: "Dateigröße",
            minutes: "minutes",
            // Messeges APSSO 
            success: "Erfolg",
            APSSOsuccess: "Sie haben den Premium-Genehmigungsplan erfolgreich in einem neuen Tab geöffnet.",
            retry: "Wiederholen",
            failed: "Fehlgeschlagen",
            APPSSOfailed: "Der Premium-Genehmigungsplan konnte nicht geöffnet werden.",
            failedBadRequest: "Hoppla! Da stimmt etwas nicht. Bitte überprüfen Sie Ihre Anfrage und versuchen Sie es erneut.",
            failedNotFound: "Hoppla! Es scheint, dass die Kundendaten nicht gefunden werden können. Bitte versuchen Sie es später erneut.",
            failedServiceUnavailable: "Hoppla! Sie konnten nicht zum Premium-Zustimmungsplan hinzugefügt werden.",
            failedInternalServerError: "Hoppla! Wir haben technische Schwierigkeiten. Unser Team arbeitet bereits daran, das Problem zu beheben. Bitte versuchen Sie es später erneut.",
            pleaseEnterAtLeast3characters: "Bitte mindestens 3 Zeichen in das Suchfeld eingeben",
            odbButtonHeader: "Bestellanfrage",
            odbPopupTitle: "Gerne können Sie eine Anfrage an unser Team weiterleiten. Bitte geben Sie Ihre Kontaktdaten unten ein",
            odbEmailAddress: "E-Mailadresse",
            odbOrderType: "Bestelltyp",
            odbFixedOrder: "Verbindliche Bestellung",
            odbNonBindungTestOrder: "Testbestellung",
            odbStreet: "Straße",
            odbNR: "Hausnummer",
            odbPostCode: "PLZ",
            odbLocation: "Stadt",
            odbAuthPopupTitle: "Gerne können Sie Ihre Preisanfrage an unser Team weiterleiten.Wir setzen uns mit Ihnen bezüglich der gesuchten Publikation umgehend in Verbindung.Bitte geben Sie den von Ihnen gewünschten Titel und die benötigte Titelanzahl hier an:",
            odbUserInfo: "Bemerkungen(Nutzerangaben)",
            unAuthUserInfo: "Nutzerangaben / Abweichende Lieferadresse / Bemerkungen",
            completeRecaptcha: "Bitte füllen Sie das reCAPTCHA aus, bevor Sie das Formular absenden.",
            NamePopup: "Name",
            EnterNamePopup: "Name eingeben",
            AddCommentPopup: "Kommentar hinzufügen",
            SaveSearchPopup: "Suche speichern",
            CreationTimePopup:"Erstellt am",
            DescriptionPopup: "Beschreibung",
            AddBookmarkPopup: "Ihre Suche wurde gespeichert",
            AddBookmarkPopupError: " Lesezeichen konnte nicht erstellt werden",
            deletedSuccess: "Lesezeichen gelöscht",
            updatedSuccess: "Erfolgreich aktualisiert",
            errorOccured: "Fehler aufgetreten",
            confirmDeleteBody: "Möchten Sie diesen Eintrag entfernen ?",
            yesDelete: "Löschen",
            noCancel: "Abbrechen",
            personIdentifier:"weitere Produkte dieses Autors"
        }
    };

    static lang(): string {
        let cult = Cookies.get(langCookieName) || "en";
        const n = cult.indexOf("-");
        if (n > -1) cult = cult.substr(0, n);

        const cults = Object.keys(this.__resources);
        if (!_.includes(cults, cult)) cult = cults[0];
        return cult;
    }

    static getString(name: string, defaultValue: string = ""): string {
        if (!name) return defaultValue;

        const lang = this.lang();
        var cname = _.camelCase(name);
        return (_.property(`${lang}.${cname}`)(this.__resources) || _.property(`${lang}.${name}`)(this.__resources) || defaultValue) as string;
    }
}
(window as any).ResourceHelper = ResourceHelper;